/**
 * Realza cualquier carrusel horizontal marcado con [data-wk-carousel-track]:
 * genera puntos reales (no <span>, son <button> con 22px de objetivo táctil),
 * mide el ancho real de la tarjeta para las flechas (nada de scrollBy mágico),
 * y agrega arrastre con mouse (los toques ya funcionan por scroll nativo).
 * Se reinicializa solo tras cada shopify:section:load del editor de temas.
 */
(function () {
  var REDUCE_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function step(track) {
    var gap = parseFloat(track.dataset.wkCarouselTrack || track.dataset.wkGap || '16') || 16;
    var card = track.firstElementChild;
    return card ? card.getBoundingClientRect().width + gap : 280;
  }

  function scrollToStep(track, left) {
    track.scrollTo({ left: left, behavior: REDUCE_MOTION ? 'auto' : 'smooth' });
  }

  function buildDots(track, dotsContainer) {
    dotsContainer.innerHTML = '';
    var cards = Array.from(track.children);
    cards.forEach(function (card, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'wk-carousel-dot';
      dot.setAttribute('aria-label', card.getAttribute('data-wk-label') || ('Ir al elemento ' + (i + 1) + ' de ' + cards.length));
      var pill = document.createElement('span');
      pill.className = 'wk-carousel-dot__pill';
      dot.appendChild(pill);
      dot.addEventListener('click', function () {
        scrollToStep(track, i * step(track));
      });
      dotsContainer.appendChild(dot);
    });
  }

  function syncDots(track, dotsContainer) {
    var s = step(track);
    var idx = s ? Math.round(track.scrollLeft / s) : 0;
    Array.from(dotsContainer.children).forEach(function (dot, i) {
      dot.classList.toggle('wk-carousel-dot--active', i === idx);
    });
  }

  function initDrag(track) {
    var dragging = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.target.closest('button, input, textarea, a')) return;
      dragging = true;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('wk-carousel-track--dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      track.scrollLeft = startScroll - (e.clientX - startX);
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('wk-carousel-track--dragging');
      var s = step(track);
      if (!s) return;
      var target = Math.round(track.scrollLeft / s) * s;
      scrollToStep(track, target);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', function () { if (dragging) endDrag(); });
  }

  function initTrack(track) {
    if (track.dataset.wkCarouselInit) return;
    track.dataset.wkCarouselInit = '1';

    var wrapper = track.closest('[data-wk-carousel]') || track.parentElement;
    var dotsContainer = wrapper.querySelector('[data-wk-carousel-dots]');
    var prevBtn = wrapper.querySelector('[data-wk-carousel-prev]');
    var nextBtn = wrapper.querySelector('[data-wk-carousel-next]');

    if (dotsContainer) {
      buildDots(track, dotsContainer);
      syncDots(track, dotsContainer);
      track.addEventListener('scroll', function () { syncDots(track, dotsContainer); }, { passive: true });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToStep(track, track.scrollLeft - step(track)); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToStep(track, track.scrollLeft + step(track)); });

    initDrag(track);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-wk-carousel-track]').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
